import Script from "next/script";
import React from "react";

const PDP24Stream = ({ brand, sku, locale }) => {
  return (
    <>
      <Script async id="pdp-script-24-stream" strategy="lazyOnload">
        {`
      (function(w,d,s,o){var f=d.getElementsByTagName(s)[0];var j=d.createElement(s);
        w.TTLStreamReady = new Promise((resolve) => {
        j.async=true;j.src= 'https://content.24ttl.stream/widget.js';f.parentNode.insertBefore(j,f);
        j.onload = function () {
            w.ttlStream = new TTLStream(o); resolve(w.ttlStream);
          };
        });
      })(window,document,'script',{});
    `}
      </Script>
      <Script async id="pdp-script-24-stream-2" strategy="lazyOnload">
        {`
      TTLStreamReady.then(() => {
        ttlStream.findAndInsert({
          "brand": "${brand}",
          "productId": "${sku}",
          "retailerDomain": "abdulwahed.com",
          "templateType": "master_template",
          "resultType": "html",
          "contentType": "minisite",
          "el": ".exampleWrapperContent",
          "language": "${locale === "en" ? "sa_en" : "sa_ar"}"
        });
      });
    `}
      </Script>
    </>
  );
};

export default PDP24Stream;
